import { isSubscriptionEnabled, isSubscribedTo } from 'shared/ui-selectors/channel/pricing';

export function canAccessChannelWithSubscription(channel) {
  return isSubscriptionEnabled(channel) && isSubscribedTo(channel);
}



// WEBPACK FOOTER //
// ./src/widget/ui-selectors/channel-access.js